const DEFAULT_HELP = 'default_help'; // 缺省帮助
const REGISTER_HELP = 'register_help'; // 注册页面帮助
const LOGIN_HELP = 'login_help'; // 登录页面帮助
const USER_INFO = 'user_info'; // 用户信息说明
const HOME_HElP = 'home_help'; // 首页提示帮助
const UPLOAD_HELP = 'upload_help'; // 媒体上传帮助说明
const SCROLL_SUBTITLE = 'scroll_subtitle'; // 滚动字幕
const MEDIA_PLAY_IMAGE = 'media_play_image'; // 媒体播放-图片视频
const MEDIA_PLAY_TEXT = 'media_play_text'; // 媒体播放-字幕
const MEDIA_PLAY_MUSIC = 'media_play_music'; // 媒体播放-音乐
const MEDIA_PLAY_GAME = 'media_play_game'; // 媒体播放-游戏
const TEMPLATE = 'template'; // 字幕 -文稿模版
const PARAM_SETTING_DEVICENAME = 'param_setting_devicename'; // 参数与设置-设备昵称
const PARAM_SETTING_SCREEN_ANGLE = 'param_setting_angle'; // 参数与设置-屏幕角度
const PARAM_SETTING_SCREEN_LIGHT = 'param_setting_light'; // 参数与设置-屏幕亮度
const PARAM_SETTING_SCREEN_MODE = 'param_setting_mode'; // 参数与设置-分屏模式
const PARAM_SETTING_SCREEN_TOUCH = 'param_setting_touch'; // 参数与设置-触摸功能
const PARAM_SETTING_APP_SELF = 'param_setting_app_self'; // 参数与设置-app自运行
const PARAM_SETTING_DEVICE_ADMIN = 'param_setting_device_admin'; // 参数与设置-设备管理员
const PARAM_SETTING_DEVICE_EXAMINE = 'param_setting_device_examine'; // 参数与设置-运行检测
const PARAM_SETTING_DEVICE_ID = 'param_setting_device_id'; // 参数与设置-设备编号
const PARAM_SETTING_APP_VERSION = 'param_setting_app_versions'; // 参数与设置-APP版本号
const SCREEN_SHOT = 'screen_shot'; // 远程截屏
const DEVICE_ADMIN = 'device_admin'; // 设备管理员
const DEVICE_SUPERADMIN = 'device_superadmin'; // 设备超级管理员
const DEVICE_COMMONADMIN = 'device_commonadmin'; // 设备普通管理员
const SERVICE_FEE_HELP = 'service_fee_help'; // 服务费帮助
const RESET_HELP = 'reset_help'; // 重置与解绑帮助
const UPGRADE_APP_HELP = 'update_app_help'; // 版本与升级
const WINDOWS_HELP = 'windows_help'; // 分屏功能帮助
const FREE_BROADCAST_HELP = 'free_broadcast_help'; // 配音广播制作
const CASH_PRIZE_HELP = 'cash_prize_help'; // 兑奖帮助
const RAFFLE_HELP = 'raffle_help'; // 抽奖游戏制作
const VALID_CODE_HELP = 'valid_code_help'; // 手机验证码
const GET_INVOICE_HELP = 'get_invoice_help'; // 索要发票
const INVOICES_HELP = 'invoices_help'; // 发票记录
const ACTIVATION_HELP = 'activation_help'; // 激活设备
const BILL_HELP = 'bill_list_help'; // 历史账单
const WX_BIND_HELP = 'wx_bind_help'; // 微信绑定

export {
	DEFAULT_HELP,
	REGISTER_HELP,
	LOGIN_HELP,
	USER_INFO,
	HOME_HElP,
	UPLOAD_HELP,
	SCROLL_SUBTITLE,
	MEDIA_PLAY_IMAGE,
	MEDIA_PLAY_TEXT,
	MEDIA_PLAY_MUSIC,
	MEDIA_PLAY_GAME,
	TEMPLATE,
	PARAM_SETTING_DEVICENAME,
	PARAM_SETTING_SCREEN_ANGLE,
	PARAM_SETTING_SCREEN_LIGHT,
	PARAM_SETTING_SCREEN_MODE,
	PARAM_SETTING_SCREEN_TOUCH,
	PARAM_SETTING_APP_SELF,
	PARAM_SETTING_DEVICE_ADMIN,
	PARAM_SETTING_DEVICE_ID,
	PARAM_SETTING_DEVICE_EXAMINE,
	PARAM_SETTING_APP_VERSION,
	SCREEN_SHOT,
	DEVICE_ADMIN,
	DEVICE_SUPERADMIN,
	DEVICE_COMMONADMIN,
	SERVICE_FEE_HELP,
	RESET_HELP,
	UPGRADE_APP_HELP,
	WINDOWS_HELP,
	FREE_BROADCAST_HELP,
	CASH_PRIZE_HELP,
	RAFFLE_HELP,
	VALID_CODE_HELP,
	GET_INVOICE_HELP,
	INVOICES_HELP,
	ACTIVATION_HELP,
	BILL_HELP,
	WX_BIND_HELP,
};
